export default "__VITE_ASSET__ChUXt8X5__"